var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrapes = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2V8",
    stroke: "#558B2F",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C12 4 14 2 16 2.5",
    stroke: "#558B2F",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C12 4 10 2 8 2.5",
    stroke: "#558B2F",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9.5,
    r: 2.2,
    fill: "#6A0DAD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9.5,
    r: 2.2,
    fill: "#6A0DAD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 13,
    r: 2.2,
    fill: "#7B1FA2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 2.2,
    fill: "#7B1FA2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 13,
    r: 2.2,
    fill: "#7B1FA2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 16.5,
    r: 2.2,
    fill: "#8E24AA"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 16.5,
    r: 2.2,
    fill: "#8E24AA"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19.5,
    r: 2,
    fill: "#9C27B0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrapes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grapes.9cf08bef15da097cb375e62ad0f9a631.svg";